module.exports = __webpack_public_path__ + "img/9788989571551.7ab8b9a4.jpg";